export default __webpack_public_path__ + "static/media/sc1.f10ac641.png";